import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { patientReports } from "app/services/transmission/patient";
import { BASE_URL } from "static/constants";

export const patientProfileReportApi = createApi({
  reducerPath: "patientProfileReportApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    fetchPatientReports: query({
      queryFn: ({ patientSerialNumber, page, pageSize, search }) => {
        return {
          data: patientReports(patientSerialNumber, page, pageSize, search),
        };
      },
    }),
  }),
});

export const { useFetchPatientReportsQuery } = patientProfileReportApi;
